<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['viewers-news']['width']" [height]="class['viewers-news']['height']"
        (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="field-row">
              <div class="config-name">
                <!-- Font Family -->
                <div style="width:65%">
                  <mat-form-field style="width:100%">
                    <mat-label>Font</mat-label>
                    <mat-select
                      [(ngModel)]="class['viewers-news__wrapper']['font-family']"
                      (ngModelChange)="updateClass();">
                      <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Font size -->
                <div style="width:35%">
                  <mat-form-field style="width:100%">
                    <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                    <input matInput type="number" [min]="1" [max]="200"
                      [ngModel]="class['viewers-news__content']['font-size'] | vhnumber"
                      (ngModelChange)="class['viewers-news__content']['font-size'] = $event +'px'"
                      (blur)="updateClass()">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/Màu chữ) -->
            <div class="field-row">
              <div class="config-font">
                <p class="title">{{'kieu_chu' | translate}}</p>
                <div class="config-name">
                  <!-- In đậm -->
                  <button class="font-text-btn" title="Bold" nz-button [nzType]="
                    class['viewers-news__content']['font-weight'] >= 700
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['viewers-news__content']['font-weight'] =
                        class['viewers-news__content']['font-weight'] >= 700
                          ? '400'
                          : '700'
                    "(click)="updateClass();">
                    <span style="font-weight:600;">B</span>
                  </button>
                  <!-- In nghiêng -->
                  <button class="font-text-btn" title="Italic" nz-button [nzType]="
                    class['viewers-news__content']['font-style'] == 'italic'
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['viewers-news__content']['font-style'] =
                        class['viewers-news__content']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal'
                    "(click)="updateClass();">
                    <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Gạch dưới -->
                  <button class="font-text-btn" title="Underline" nz-button [nzType]="
                    class['viewers-news__wrapper']['text-decoration'] == 'underline'
                      ? 'primary'
                      : 'default'
                    "(click)="
                      class['viewers-news__wrapper']['text-decoration'] =
                        class['viewers-news__wrapper']['text-decoration'] == 'none'
                          ? 'underline'
                          : 'none'
                    "(click)="updateClass();">
                    <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                  </button>
                  <!-- Màu chữ -->
                  <input class="input-color" style="width:22%" type="button" 
                    [style.background]="class['viewers-news__wrapper']['color']"
                    [cpOKButton]="true" [(colorPicker)]="class['viewers-news__wrapper']['color']"
                    (colorPickerClose)="updateClass()" />
                </div>
                <!-- Độ đậm -->
                <div class="my-3">
                  <div class="config-name">
                    <p>{{'do_dam' | translate}}</p>
                    <nz-input-number
                      [(ngModel)]="class['viewers-news__content']['font-weight']"
                      (nzBlur)="updateClass()"
                      [nzMin]="100" [nzMax]="900" [nzStep]="100">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider  [nzMin]="100" [nzMax]="900" [nzStep]="100"
                        [(ngModel)]="class['viewers-news__content']['font-weight']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50"
                      [ngModel]="class['viewers-news__content']['letter-spacing'] | vhnumber"
                      (ngModelChange)="class['viewers-news__content']['letter-spacing'] = $event +'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['viewers-news__content']['letter-spacing'] | vhnumber"
                        (ngModelChange)="class['viewers-news__content']['letter-spacing'] = $event +'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div>
                  <div class="config-name">
                     <p>{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                      [(ngModel)]="this.class['viewers-news__content']['line-height']" (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['viewers-news__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['viewers-news__content']"
                [textWrapperClass]="class['viewers-news__wrapper']"
                [filterConfig]="config['filter']"
                [isShape]="false"
        >
        </app-text-style-config>
      </li>
      <!-- BIỂU TƯỢNG -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-symbol-config
              [device]="device"
              [class]="class"
              [config]="config"
              [symbolClass]="class['viewers-news__wrapper']"
              [fontSizeIconClass]="class['viewers-news__icon-inner']"
              [symbolConfig]="config['icon']"
              [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['user-name']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="editor-field">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
  </div>
</div>